import { render, staticRenderFns } from "./ItemPuestos.vue?vue&type=template&id=58e17872&"
import script from "./ItemPuestos.vue?vue&type=script&lang=js&"
export * from "./ItemPuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports